export const RentReportingTabs = {
  Subscription: "Subscription",
  PMSLedger: "PMS_Ledger"
} as const;
